import { render, staticRenderFns } from "./PricingForSpecialGroupsSection.vue?vue&type=template&id=39552768&scoped=true"
import script from "./PricingForSpecialGroupsSection.vue?vue&type=script&lang=js"
export * from "./PricingForSpecialGroupsSection.vue?vue&type=script&lang=js"
import style0 from "./PricingForSpecialGroupsSection.vue?vue&type=style&index=0&id=39552768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39552768",
  null
  
)

export default component.exports